<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>Attendance Summary Report</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStream()"
                        @click="putnull" />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null && sel_ay_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="str" label="Stream" outlined @click="putnull" />
                </v-col>
                <v-col sm="2" v-if="div_list != null && sel_std_data">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" multiple dense rounded required v-model="div" item-value="id"
                        :items="div_list" item-text="division" label="Division" outlined />
                </v-col>
                <v-col sm="2" v-if="div">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                        item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col sm="2" v-if="div">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="report" :items="report_list"
                        item-text="name" item-value="id" label="Report" outlined persistent-hint hint="Select Report"
                        @change="to_date= ''; date= ''" />
                </v-col>
                
            </v-row>
            
            <v-row justify="center">
                    <v-col sm="2" v-if="sel_std_data && status && report==0">
                    <v-icon color="error">*</v-icon>
                    From Date :
                    <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="date" />
                </v-col>
                <v-col sm="2" v-if="sel_std_data && date ">
                    <v-icon color="error">*</v-icon>
                    To Date :
                    <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="to_date" />
                </v-col>
                <v-col sm="2" v-if="sel_ay_data && sel_std_data && date && to_date && report!=1 && report!=2">
                    <v-btn class="mt-6 button" @click="CallByReports()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
                 <v-col sm="2" v-if="sel_ay_data && sel_std_data && report!=0">
                    <v-btn class="mt-6 button" @click="CallByReports();" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
                
            </v-row>
        </v-card>
        <br />
        <v-row dense>
            <v-btn v-if="mainList != '' && mainList != null && report == 0" class="mr-2 mt-5 no-display" tile outlined color="warning"
                @click="print()"> <v-icon left>mdi-printer</v-icon> Print Report<v-icon right></v-icon> </v-btn>

             <v-btn v-if="categoryWiseStudents != '' && categoryWiseStudents != null && report == 1" class="mr-2 mt-5 no-display" tile outlined color="warning"
                @click="print()"> <v-icon left>mdi-printer</v-icon> Print Report<v-icon right></v-icon> </v-btn>

             <v-btn v-if="final_religion_list != '' && final_religion_list!= null && report == 2" class="mr-2 mt-5 no-display" tile outlined color="warning"
                @click="print()"> <v-icon left>mdi-printer</v-icon> Print Report<v-icon right></v-icon> </v-btn>

            <v-btn v-if="report == 0 && mainList != null && Object.keys(mainList).length > 0"class="ml-2 mt-5 no-display" rounded
                color="success" outlined  @click="downloadFile()" :loading="loader">
            <v-icon color="success">mdi-export</v-icon> Export</v-btn>

            <v-btn v-if="report == 1 && categoryWiseStudents != null && categoryWiseStudents.length > 0" class="ml-2 mt-5 no-display" rounded
                color="success" outlined @click="downloadCategoryFile()" :loading="loader">
                <v-icon color="success">mdi-export</v-icon> Export </v-btn>

            <v-btn v-if="report == 2 && religionWiseStudentList != null && religionWiseStudentList.length > 0" class="ml-2 mt-5 no-display" rounded
            color="success" outlined @click="downloadReligionFile()":loading="loader">
            <v-icon color="success">mdi-export</v-icon> Export </v-btn>


            <!-- <v-col v-if="mainList != '' && mainList != null" class="mr-2 mt-3 no-display" cols="12" sm="2" md="2">
                <v-autocomplete
                    class="ml-2"
                    flat
                    hide-details                                
                    rounded
                    dense
                    outlined                                
                    label="Class & Division"
                    multiple
                    clearable
                    :items="dataValueList('class_division')"
                    v-model="filters.class_division"
                ></v-autocomplete>
         </v-col> -->
            <!-- <v-spacer></v-spacer>
          <v-col v-if="mainList != '' && mainList != null" class="mr-2 no-display" cols="12" sm="5" md="5">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                hide-details></v-text-field>
          </v-col> -->
        </v-row>
        <!-- {{org_basic_data}} -->
        <div v-for="(rows, date) in mainList" :key="date" class="mb-10" v-if="report==0">

            <!-- Header Table -->
            <table
                border="1"
                cellspacing="0"
                cellpadding="5"
                width="100%"
                id="my-table-id"
                style="border-collapse: collapse;"
            >

                <tr>
                <td width="15%" align="center">
                    <img
                    v-if="org_basic_data.trust_logo"
                    :src="org_basic_data.trust_logo"
                    width="100"
                    height="120"
                    >
                </td>

                <td width="70%" align="center">

                    <div>
                    <strong>{{ org_basic_data.trust_name }}</strong>
                    </div>

                    <div>
                    <strong>{{ org_basic_data.school_name }}</strong>
                    </div>

                    <div>
                    <b>Stream :</b> {{ sel_std_data.str }}
                    &nbsp;&nbsp;
                    <b>Group :</b> All
                    </div>

                    <div>
                    <b>Batch :</b> {{ sel_ay_data.ay }}
                    </div>

                    <div>
                    <b>Date :</b> {{ date }}
                    </div>

                    <br>

                    <div>
                    <b>Attendance Summary Report</b>
                    </div>

                </td>

                <td width="15%" align="center">
                    <img
                    v-if="org_basic_data.school_logo"
                    :src="org_basic_data.school_logo"
                    width="100"
                    height="120"
                    >
                </td>
                </tr>

            </table>

            <table
                border="1"
                cellspacing="0"
                cellpadding="5"
                width="100%"
                style="border-collapse: collapse; margin-top:-1px;"
            >

                <thead>

                <tr>
                    <th rowspan="2">Sr.No.</th>
                    <th rowspan="2">Std</th>
                    <th colspan="3">Strength</th>
                    <th colspan="3">Absent</th>
                    <th colspan="3">Present</th>
                </tr>
                <tr>
                    <th>Boys</th>
                    <th>Girls</th>
                    <th>Total</th>
                    <th>Boys</th>
                    <th>Girls</th>
                    <th>Total</th>
                    <th>Boys</th>
                    <th>Girls</th>
                    <th>Total</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in rows":key="row.srno" >
                    <td>{{ row.srno }}</td>
                    <td>{{ row.class_division }}</td>
                    <td>{{ row.boys_strength }}</td>
                    <td>{{ row.girls_strength }}</td>
                    <td>{{ row.total_strength }}</td>
                    <td>{{ row.boys_absent }}</td>
                    <td>{{ row.girls_absent }}</td>
                    <td>{{ row.total_absent }}</td>
                    <td>{{ row.boys_present }}</td>
                    <td>{{ row.girls_present }}</td>
                    <td>{{ row.total_present }}</td>
                </tr>
                </tbody>
            </table>
            <br><br>
        </div>   

                <div v-if="report == 1 && categoryWiseStudents.length>0">
                <table border="1" cellspacing="0" cellpadding="5" width="100%" id="my-table-id" style="border-collapse: collapse;"
                    >
                        <tr>
                            <td width="15%" align="center">

                                <img
                                    v-if="org_basic_data.trust_logo"
                                    :src="org_basic_data.trust_logo"
                                    width="100"
                                    height="120"
                                >

                            </td>

                            <td width="70%" align="center">

                                <div>
                                    <strong> {{ org_basic_data.trust_name }}</strong>
                                </div>
                                <div>
                                    <strong>{{ org_basic_data.school_name }} </strong>
                                </div>

                                <div>
                                    <b>Stream :</b>
                                    {{ sel_std_data.str }}

                                    &nbsp;&nbsp;

                                    <b>Group :</b>
                                    All
                                </div>

                                <div>
                                    <b>Batch :</b> {{ sel_ay_data.ay }}
                                </div>

                                <br>
                              <div>
                                    <b>  Category Wise Attendance Summary Report </b>
                                </div>

                            </td>

                            <td width="15%" align="center">

                                <img
                                    v-if="org_basic_data.school_logo"
                                    :src="org_basic_data.school_logo"
                                    width="100"
                                    height="120"
                                >

                            </td>

                        </tr>

                    </table>

                    <div
                        v-for="(standardRows, standard) in categoryWiseGrouped"
                        :key="standard"
                        class="standard-section"
                    >
                        <table
                            border="1"
                            cellspacing="0"
                            cellpadding="5"
                            width="100%"
                            style="
                                border-collapse: collapse;
                                margin-top: 15px;
                            "
                        >

                            <tr>

                                <th
                                    colspan="5"
                                    style="
                                        text-align: center;
                                        font-size: 16px;
                                        padding: 8px;
                                    "
                                >
                                    Standard : {{ standard }}
                                </th>

                            </tr>

                        </table>
                        <table
                            border="1"
                            cellspacing="0"
                            cellpadding="5"
                            width="100%"
                            style="
                                border-collapse: collapse;
                                margin-top: -1px;
                            "
                        >

                            <thead>
                                <tr>
                                    <th> Sr.No.
                                    </th>
                                    <th> Division </th>
                                    <th>Category</th>
                                    <th> Boys</th>
                                    <th> Girls </th>
                                    <th>  Total </th>

                                </tr>

                            </thead>
                            <tbody>
                    <tr v-for="(row, index) in standardRows"  :key="index"  v-if="Number(row.boys_count || 0) > 0 || Number(row.girls_count || 0) > 0"  >
                        <td> {{ index + 1 }} </td>
                        <td>{{ row.division }} </td>
                        <td> {{ row.category_name }}</td>
                        <td>  {{ row.boys_count }} </td>
                        <td> {{ row.girls_count }} </td>
                        <td> {{ Number(row.boys_count || 0) + Number(row.girls_count || 0)}}
                        </td>
                    </tr>
                    <tr style="font-weight: bold;">
                        <td>
                            -
                        </td>
                        <td>
                            -
                        </td>
                        <td>
                            Total
                        </td>
                        <td>{{standardRows.reduce((sum, row) => sum + Number(row.boys_count || 0),0)}}
                        </td>
                        <td>{{standardRows.reduce((sum, row) =>sum + Number(row.girls_count || 0),0)}}
                        </td>
                        <td> {{standardRows.reduce((sum, row) => sum + Number(row.boys_count || 0) +Number(row.girls_count || 0), 0)}}
                        </td>
                    </tr>
                </tbody>
        </table>
                        <br>
                    </div>
                </div>

                <div v-if="report == 2 && religionWiseStudentList.length>0">
                    <table
                        border="1"
                        cellspacing="0"
                        cellpadding="5"
                        width="100%"
                        id="my-table-id"
                        style="border-collapse: collapse;"
                    >

                        <tr>
                            <td width="15%" align="center">

                                <img
                                    v-if="org_basic_data.trust_logo"
                                    :src="org_basic_data.trust_logo"
                                    width="100"
                                    height="120"
                                >
                            </td>
                            <td width="70%" align="center">

                                <div>
                                    <strong>{{ org_basic_data.trust_name }} </strong>
                                </div>

                                <div>
                                    <strong>{{ org_basic_data.school_name }}</strong>
                                </div>

                                <div>
                                    <b>Stream :</b> {{ sel_std_data.str }}

                                    &nbsp;&nbsp;

                                    <b>Group :</b>
                                    All
                                </div>

                                <div>
                                    <b>Batch :</b> {{ sel_ay_data.ay }}
                                </div>
                                <br>

                                <div>
                                    <b> Religion Wise Attendance Summary Report </b>
                                </div>

                            </td>
                            <td width="15%" align="center">

                                <img
                                    v-if="org_basic_data.school_logo"
                                    :src="org_basic_data.school_logo"
                                    width="100"
                                    height="120"
                                >
                            </td>
                      </tr>

                    </table>

                    <div
                        v-for="(standardRows, standard) in religionWiseGrouped"
                        :key="standard"
                        class="standard-section"
                    >

                        <!-- Standard Title -->
                        <table
                            border="1"
                            cellspacing="0"
                            cellpadding="5"
                            width="100%"
                            style="
                                border-collapse: collapse;
                                margin-top: 15px;
                            "
                        >

                            <tr>

                                <th
                                    colspan="5"
                                    style="
                                        text-align: center;
                                        font-size: 16px;
                                        padding: 8px;
                                    "
                                >
                                    Standard : {{ standard }}
                                </th>

                            </tr>

                        </table>


                        <!-- Standard Attendance Table -->
                        <table
                            border="1"
                            cellspacing="0"
                            cellpadding="5"
                            width="100%"
                            style="
                                border-collapse: collapse;
                                margin-top: -1px;
                            "
                        >

                            <thead>

                                <tr>

                                    <th> Sr.No.</th>
                                    <th> Division</th>
                                    <th>Religion</th>
                                    <th> Boys</th>
                                    <th> Girls</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                        <tbody>
                    <tr v-for="(row, index) in standardRows" :key="index" v-if="Number(row.boys_count || 0) > 0 || Number(row.girls_count || 0) > 0" >
                        <td>{{ index + 1 }} </td>
                        <td> {{ row.division }} </td>
                        <td> {{ row.religion_name }}</td>
                        <td>{{ row.boys_count }} </td>
                        <td> {{ row.girls_count }} </td>
                        <td>{{Number(row.boys_count || 0) + Number(row.girls_count || 0)}} </td>
                    </tr>
                    <tr
                        style="
                            font-weight: bold;
                            border-top: 2px solid black;
                        "
                    >
                        <td>
                            -
                        </td>

                        <td>
                            -
                        </td>
                        <td> Total </td>
                        <td> {{standardRows.reduce( (sum, row) => sum + Number(row.boys_count || 0),  0 ) }}
                        </td>
                        <td> {{ standardRows.reduce((sum, row) =>sum + Number(row.girls_count || 0),  0) }}
                        </td>
                        <td>{{ standardRows.reduce((sum, row) =>  sum + Number(row.boys_count || 0) + Number(row.girls_count || 0), 0)}}
                        </td>
                    </tr>

                </tbody>

                        </table>

                        <br>

                    </div>
                

                </div>


                <div v-if="report == 1 && categoryWiseStudents.length>0"
                    style="
                        text-align: center;
                        font-weight: bold;
                        font-size: 16px;
                        margin-top: 20px;
                        margin-bottom: 5px;
                    "
                >
                    Category Wise Overall Standard Summary
                </div>
                <table
                    border="1"
                    cellspacing="0"
                    cellpadding="5"
                    width="100%"
                    style="border-collapse: collapse; margin-top: 20px;"
                    v-if="report == 1 && categoryWiseStudents.length>0"
                >

                    <thead>

                        <tr>

                            <th>
                                Category
                            </th>

                            <th
                                v-for="standard in categoryStandards"
                                :key="standard"
                            >
                                {{ standard }}
                            </th>

                        </tr>

                    </thead>
                    <tbody>
                        <tr
                            v-for="(row, index) in categoryStandardTable"
                            :key="index"
                             v-if="categoryStandards.some(standard => Number(row[standard] || 0) > 0)"
                        >

                            <td>
                                {{ row.category_name }}
                            </td>

                            <td
                                v-for="standard in categoryStandards"
                                :key="standard"
                            >
                                {{ Number(row[standard] || 0) > 0 ? row[standard] : 0 }}

                            </td>

                        </tr>
                        <tr>

                            <th>
                                Total
                            </th>

                            <th
                                v-for="standard in categoryStandards"
                                :key="standard + '_total'"
                            >

                                {{
                                    categoryStandardTable.reduce(
                                        (sum, row) => {
                                            return sum + Number(row[standard] || 0);
                                        },
                                        0
                                    )
                                }}

                            </th>

                        </tr>

                    </tbody>

                </table>

                <div v-if="report == 2 && religionWiseStudentList.length>0"
                style="
                text-align: center;
                font-weight: bold;
                font-size: 16px;
                margin-top: 20px;
                margin-bottom: 5px;
            "
        >
            Religion Wise Overall Standard Summary
                </div>
                <table
                    border="1"
                    cellspacing="0"
                    cellpadding="5"
                    width="100%"
                    style="border-collapse: collapse;"
                    v-if="report==2 && religionWiseStudentList.length>0"
                >

                    <thead>

                        <tr>

                            <th>
                                Religion
                            </th>

                            <th
                                v-for="standard in religionStandards"
                                :key="standard"
                            >
                                {{ standard }}
                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        <!-- Religion rows -->

                        <tr
                            v-for="(row, index) in religionStandardTable"
                            :key="index"
                           v-if="religionStandards.some(standard => Number(row[standard] || 0) > 0)"
                        >

                            <td>
                                {{ row.religion_name }}
                            </td>

                            <td
                                v-for="standard in religionStandards"
                                :key="standard"
                               
                            >
                                {{ Number(row[standard] || 0) > 0 ? row[standard] : 0 }}
                            </td>

                        </tr>


                        <!-- Total row -->

                        <tr>

                            <th>
                                Total
                            </th>

                            <th
                                v-for="standard in religionStandards"
                                :key="standard + '_total'"
                            >

                                {{
                                    religionStandardTable.reduce(
                                        (sum, row) =>
                                            sum + Number(row[standard] || 0),
                                        0
                                    )
                                }}

                            </th>

                        </tr>

                    </tbody>

                </table>
    

 </div>
</template>

<script>
    import axios from "axios";
    import * as XLSX from "xlsx";
    import "@/assets/css/color.css";
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            Breadcrumbs,
        },

        data() {
            return {
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                overlay: false,
                fetch_loader: false,
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                report_list: null,
                mainList: [],
                categoryList: [],
                religionList:[],
                categoryWiseStudents:[],
                religionWiseStudentList:[],
                final_religion_list:[],
                report: null,
                date: null,
                to_date: null,
                new_date: null,
                org_basic_data: [],
                status_list: [
                    { name: "All", id: "3" },
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                report_list: [
                    { name: "Gender wise", id: "0" },
                    { name: "Category wise", id: "1" },
                    { name: "Religion wise", id: "2" },
                ],
                status: null,
                filters: {
                    class_division: [],
                },
                filterArr: [],
                headers1: [
                    {
                        text: "Sr. No.",
                        value: "srno",
                    },
                    {
                        text: "Class & Division",
                        align: "center",
                        value: "class_division",
                    },
                    {
                        text: "Total Strength",
                        align: "center",
                        value: "total_strength",
                    },
                    {
                        text: "No. of Boys Present",
                        align: "center",
                        value: "boys_present",
                    },
                    {
                        text: "No. of Girls Present",
                        align: "center",
                        value: "girls_present",
                    },
                    {
                        text: "No. of Boys Absent",
                        align: "center",
                        value: "boys_absent",
                    },
                    {
                        text: "No. of Girls Absent",
                        align: "center",
                        value: "girls_absent",
                    },
                    {
                        text: "Total Absent",
                        align: "center",
                        value: "total_absent",
                    },
                    {
                        text: "Total Present",
                        align: "center",
                        value: "total_present",
                    },
                ],
            };
        },
        watch: {
            div(newVal, oldVal) {
                const allId = "ALL";
                const allIds = this.div_list.map(d => d.id); 

                // CASE 1: Only "ALL" selected → auto select all
                if (newVal.includes(allId) && newVal.length === 1) {
                    if (JSON.stringify(newVal) !== JSON.stringify(allIds)) {
                        this.div = allIds;
                    }
                    return;
                }

                // CASE 2: Earlier ALL was selected, now ALL removed → unselect all
                if (oldVal.includes(allId) && !newVal.includes(allId)) {
                    this.div = [];
                    return;
                }
            }
        },

        computed: {
             categoryWiseGrouped() {

                const grouped = {};

                this.categoryWiseStudents.forEach(row => {

                    if (!grouped[row.standard]) {
                        grouped[row.standard] = [];
                    }

                    grouped[row.standard].push(row);

                });

                return grouped;
            },
            religionWiseGrouped() {

                const grouped = {};

                this.final_religion_list.forEach(row => {

                    if (!grouped[row.standard]) {
                        grouped[row.standard] = [];
                    }

                    grouped[row.standard].push(row);

                });

                return grouped;
            },
            categoryStandards() {

                if (
                    !this.categoryWiseStudents ||
                    this.categoryWiseStudents.length === 0
                ) {
                    return [];
                }

                return [
                    ...new Set(
                        this.categoryWiseStudents
                            .map(row => row.standard)
                            .filter(standard => standard)
                    )
                ];
            },
            categoryStandardTable() {

                const result = {};

                if (
                    !this.categoryWiseStudents ||
                    this.categoryWiseStudents.length === 0
                ) {
                    return [];
                }

                this.categoryWiseStudents.forEach(row => {

                    const standard = row.standard;
                    const category = row.category_name;

                    if (!standard || !category) {
                        return;
                    }

                    if (!result[category]) {
                        result[category] = {
                            category_name: category
                        };
                    }

                    const boys = Number(row.boys_count || 0);
                    const girls = Number(row.girls_count || 0);

                    if (!result[category][standard]) {
                        result[category][standard] = 0;
                    }

                    result[category][standard] += boys + girls;

                });

                return Object.values(result);
            },
            religionStandards() {   

                        if (
                            !this.final_religion_list ||
                            this.final_religion_list.length === 0
                        ) {
                            return [];
                        }

                        return [
                            ...new Set(
                                this.final_religion_list
                                    .map(row => row.standard)
                                    .filter(standard => standard)
                            )
                        ];
                },

            religionStandardTable() {

    const result = {};

    if (
        !this.final_religion_list ||
        this.final_religion_list.length === 0
    ) {
        return [];
    }

    this.final_religion_list.forEach(row => {

        const standard = row.standard;
        const religion = row.religion_name;

        if (!standard || !religion) {
            return;
        }

        if (!result[religion]) {
            result[religion] = {
                religion_name: religion
            };
        }

        const boys = Number(row.boys_count || 0);
        const girls = Number(row.girls_count || 0);

        if (!result[religion][standard]) {
            result[religion][standard] = 0;
        }

        result[religion][standard] += boys + girls;

    });

    return Object.values(result);
 },

            filteredItems() {
                return this.mainList.filter(item => {
                    const matchesSearch = this.search
                        ? (item.class_division && item.class_division.toLowerCase().includes(this.search.toLowerCase()))
                        : true;

                    const matchesStd = this.filters.class_division.length
                        ? this.filters.class_division.includes(item.class_division)
                        : true;

                    return matchesSearch && matchesStd;
                });
            },
        },
        methods: {
           downloadFile() {
            this.loader = true;

            try {
                if (
                    !this.mainList ||
                    typeof this.mainList !== "object" ||
                    Object.keys(this.mainList).length === 0
                ) {
                    this.showSnackbar("#b71c1c", "No data available to export.");
                    this.loader = false;
                    return;
                }

                const workbook = XLSX.utils.book_new();
                const excelData = [];

                Object.keys(this.mainList).forEach((date, dateIndex) => {

                
                    excelData.push([
                        this.org_basic_data.trust_name || "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);

                    excelData.push([
                        this.org_basic_data.school_name || "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);

                    excelData.push([
                        "Attendance Summary Report",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);
                    excelData.push([
                        "Date : " + date,
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);

                    excelData.push([
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);

                    excelData.push([
                        "Sr.No.",
                        "Std",
                        "Strength",
                        "",
                        "",
                        "Absent",
                        "",
                        "",
                        "Present",
                        "",
                        ""
                    ]);

                    excelData.push([
                        "",
                        "",
                        "Boys",
                        "Girls",
                        "Total",
                        "Boys",
                        "Girls",
                        "Total",
                        "Boys",
                        "Girls",
                        "Total"
                    ]);
                    const rows = this.mainList[date] || [];

                    rows.forEach((row) => {

                        excelData.push([
                            row.srno != null ? row.srno : "",
                            row.class_division != null
                                ? row.class_division
                                : "",

                            // Strength
                            row.boys_strength != null
                                ? row.boys_strength
                                : 0,

                            row.girls_strength != null
                                ? row.girls_strength
                                : 0,

                            row.total_strength != null
                                ? row.total_strength
                                : 0,

                            // Absent
                            row.boys_absent != null
                                ? row.boys_absent
                                : 0,

                            row.girls_absent != null
                                ? row.girls_absent
                                : 0,

                            row.total_absent != null
                                ? row.total_absent
                                : 0,

                            // Present
                            row.boys_present != null
                                ? row.boys_present
                                : 0,

                            row.girls_present != null
                                ? row.girls_present
                                : 0,

                            row.total_present != null
                                ? row.total_present
                                : 0
                        ]);

                    });

                    if (dateIndex < Object.keys(this.mainList).length - 1) {
                        excelData.push(["", "", "", "", "", "", "", "", "", "", ""]);
                        excelData.push(["", "", "", "", "", "", "", "", "", "", ""]);
                    }
                });

                const worksheet = XLSX.utils.aoa_to_sheet(excelData);

                worksheet["!merges"] = [];

                Object.keys(this.mainList).forEach((date, dateIndex) => {

                    let startRow = 0;

                    Object.keys(this.mainList)
                        .slice(0, dateIndex)
                        .forEach((previousDate) => {
                            startRow += 7;
                            startRow += this.mainList[previousDate].length;

                            if (dateIndex > 0) {
                                startRow += 2;
                            }
                        });

                    worksheet["!merges"].push({
                        s: {
                            r: startRow,
                            c: 0
                        },
                        e: {
                            r: startRow,
                            c: 10
                        }
                    });

                    worksheet["!merges"].push({
                        s: {
                            r: startRow + 1,
                            c: 0
                        },
                        e: {
                            r: startRow + 1,
                            c: 10
                        }
                    });

                    worksheet["!merges"].push({
                        s: {
                            r: startRow + 2,
                            c: 0
                        },
                        e: {
                            r: startRow + 2,
                            c: 10
                        }
                    });

                    worksheet["!merges"].push({
                        s: {
                            r: startRow + 3,
                            c: 0
                        },
                        e: {
                            r: startRow + 3,
                            c: 10
                        }
                    });

                    worksheet["!merges"].push({
                        s: {
                            r: startRow + 5,
                            c: 2
                        },
                        e: {
                            r: startRow + 5,
                            c: 4
                        }
                    });
                    worksheet["!merges"].push({
                        s: {
                            r: startRow + 5,
                            c: 5
                        },
                        e: {
                            r: startRow + 5,
                            c: 7
                        }
                    });

                    worksheet["!merges"].push({
                        s: {
                            r: startRow + 5,
                            c: 8
                        },
                        e: {
                            r: startRow + 5,
                            c: 10
                        }
                    });

                    worksheet["!merges"].push({
                        s: {
                            r: startRow + 5,
                            c: 0
                        },
                        e: {
                            r: startRow + 6,
                            c: 0
                        }
                    });

                    worksheet["!merges"].push({
                        s: {
                            r: startRow + 5,
                            c: 1
                        },
                        e: {
                            r: startRow + 6,
                            c: 1
                        }
                    });

                });

                worksheet["!cols"] = [
                    { wch: 10 }, // A Sr.No
                    { wch: 22 }, // B Std
                    { wch: 15 }, // C
                    { wch: 15 }, // D
                    { wch: 15 }, // E
                    { wch: 15 }, // F
                    { wch: 15 }, // G
                    { wch: 15 }, // H
                    { wch: 15 }, // I
                    { wch: 15 }, // J
                    { wch: 15 }  // K
                ];


                const range = XLSX.utils.decode_range(
                    worksheet["!ref"]
                );

                for (
                    let row = range.s.r;
                    row <= range.e.r;
                    row++
                ) {

                    for (
                        let col = range.s.c;
                        col <= range.e.c;
                        col++
                    ) {

                        const cellAddress = XLSX.utils.encode_cell({
                            r: row,
                            c: col
                        });

                        if (!worksheet[cellAddress]) {
                            continue;
                        }

                        worksheet[cellAddress].s = {
                            alignment: {
                                horizontal: "center",
                                vertical: "center"
                            }
                        };
                    }
                }

                Object.keys(this.mainList).forEach((date, dateIndex) => {

                    let startRow = 0;

                    Object.keys(this.mainList)
                        .slice(0, dateIndex)
                        .forEach((previousDate) => {
                            startRow += 7;
                            startRow += this.mainList[previousDate].length;

                            if (dateIndex > 0) {
                                startRow += 2;
                            }
                        });

                    const trustCell = XLSX.utils.encode_cell({
                        r: startRow,
                        c: 0
                    });

                    worksheet[trustCell].s = {
                        font: {
                            bold: true,
                            sz: 14
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        }
                    };

                    // School
                    const schoolCell = XLSX.utils.encode_cell({
                        r: startRow + 1,
                        c: 0
                    });

                    worksheet[schoolCell].s = {
                        font: {
                            bold: true,
                            sz: 13
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        }
                    };

                    // Report title
                    const titleCell = XLSX.utils.encode_cell({
                        r: startRow + 2,
                        c: 0
                    });

                    worksheet[titleCell].s = {
                        font: {
                            bold: true,
                            sz: 14
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        }
                    };

                    // Date
                    const dateCell = XLSX.utils.encode_cell({
                        r: startRow + 3,
                        c: 0
                    });

                    worksheet[dateCell].s = {
                        font: {
                            bold: true,
                            sz: 11
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        }
                    };

                    // Table headers
                    for (let r = startRow + 5; r <= startRow + 6; r++) {

                        for (let c = 0; c <= 10; c++) {

                            const cell = XLSX.utils.encode_cell({
                                r: r,
                                c: c
                            });

                            if (worksheet[cell]) {
                                worksheet[cell].s = {
                                    font: {
                                        bold: true
                                    },
                                    alignment: {
                                        horizontal: "center",
                                        vertical: "center"
                                    }
                                };
                            }
                        }
                    }

                });

                XLSX.utils.book_append_sheet(
                    workbook,
                    worksheet,
                    "Attendance Summary"
                );

            

                XLSX.writeFile(
                    workbook,
                    "AttendanceSummaryReport.xlsx"
                );

            } catch (error) {

                console.error(
                    "Excel export error:",
                    error
                );

                this.showSnackbar(
                    "#b71c1c",
                    "Unable to export Excel file."
                );

            } finally {

                this.loader = false;

            }
        },
        downloadCategoryFile() {

            this.loader = true;

            try {

                if (
                    !this.categoryWiseStudents ||
                    this.categoryWiseStudents.length === 0
                ) {
                    this.showSnackbar(
                        "#b71c1c",
                        "No category data available to export."
                    );

                    this.loader = false;
                    return;
                }


                const workbook = XLSX.utils.book_new();
                const excelData = [];
                excelData.push([
                    this.org_basic_data.trust_name || "",
                    "",
                    "",
                    "",
                    "",
                    ""
                ]);

                excelData.push([
                    this.org_basic_data.school_name || "",
                    "",
                    "",
                    "",
                    "",
                    ""
                ]);

                excelData.push([
                    "Category Wise Attendance Summary Report",
                    "",
                    "",
                    "",
                    "",
                    ""
                ]);

                excelData.push([
                    "Stream : " +
                    (this.sel_std_data
                        ? this.sel_std_data.str
                        : ""),
                    "",
                    "",
                    "",
                    "",
                    ""
                ]);

                excelData.push([
                    "Batch : " +
                    (this.sel_ay_data
                        ? this.sel_ay_data.ay
                        : ""),
                    "",
                    "",
                    "",
                    "",
                    ""
                ]);

                excelData.push([
                    "",
                    "",
                    "",
                    "",
                    "",
                    ""
                ]);
                const grouped = {};

                this.categoryWiseStudents.forEach(row => {

                    const standard = row.standard || "Unknown";

                    if (!grouped[standard]) {
                        grouped[standard] = [];
                    }

                    grouped[standard].push(row);

                });
            Object.keys(grouped).forEach(standard => {

                    const rows = grouped[standard];


                    // Standard title
                    excelData.push([
                        "Standard : " + standard,
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);


                    // Table header
                    excelData.push([
                        "Sr.No.",
                        "Division",
                        "Category",
                        "Boys",
                        "Girls",
                        "Total"
                    ]);
                    rows.forEach((row, index) => {

                        const boys =
                            Number(row.boys_count || 0);

                        const girls =
                            Number(row.girls_count || 0);

                        excelData.push([
                            index + 1,
                            row.division || "",
                            row.category_name || "",
                            boys,
                            girls,
                            boys + girls
                        ]);

                    });
                    const totalBoys = rows.reduce(
                        (sum, row) =>
                            sum + Number(row.boys_count || 0),
                        0
                    );

                    const totalGirls = rows.reduce(
                        (sum, row) =>
                            sum + Number(row.girls_count || 0),
                        0
                    );

                    const grandTotal =
                        totalBoys + totalGirls;


                    excelData.push([
                        "",
                        "",
                        "Total",
                        totalBoys,
                        totalGirls,
                        grandTotal
                    ]);
                    excelData.push([
                        "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);

                });
                const worksheet =
                    XLSX.utils.aoa_to_sheet(excelData);
                worksheet["!merges"] = [];
                worksheet["!merges"].push({
                    s: { r: 0, c: 0 },
                    e: { r: 0, c: 5 }
                });
                worksheet["!merges"].push({
                    s: { r: 1, c: 0 },
                    e: { r: 1, c: 5 }
                });

                worksheet["!merges"].push({
                    s: { r: 2, c: 0 },
                    e: { r: 2, c: 5 }
                });

                worksheet["!merges"].push({
                    s: { r: 3, c: 0 },
                    e: { r: 3, c: 5 }
                });

                worksheet["!merges"].push({
                    s: { r: 4, c: 0 },
                    e: { r: 4, c: 5 }
                });

                worksheet["!cols"] = [
                    { wch: 10 },
                    { wch: 15 },
                    { wch: 25 },
                    { wch: 15 },
                    { wch: 15 },
                    { wch: 15 }
                ];

                const range =
                    XLSX.utils.decode_range(
                        worksheet["!ref"]
                    );


                for (
                    let row = range.s.r;
                    row <= range.e.r;
                    row++
                ) {

                    for (
                        let col = range.s.c;
                        col <= range.e.c;
                        col++
                    ) {

                        const cell =
                            XLSX.utils.encode_cell({
                                r: row,
                                c: col
                            });

                        if (!worksheet[cell]) {
                            continue;
                        }

                        worksheet[cell].s = {
                            alignment: {
                                horizontal: "center",
                                vertical: "center"
                            }
                        };

                    }

                }

                for (
                    let row = range.s.r;
                    row <= range.e.r;
                    row++
                ) {

                    const categoryCell =
                        worksheet[
                            XLSX.utils.encode_cell({
                                r: row,
                                c: 2
                            })
                        ];

                    if (
                        categoryCell &&
                        categoryCell.v === "Total"
                    ) {

                        for (let col = 0; col <= 5; col++) {

                            const cell =
                                XLSX.utils.encode_cell({
                                    r: row,
                                    c: col
                                });

                            if (worksheet[cell]) {

                                worksheet[cell].s = {
                                    font: {
                                        bold: true
                                    },
                                    alignment: {
                                        horizontal: "center",
                                        vertical: "center"
                                    }
                                };

                            }

                        }

                    }

                }
                XLSX.utils.book_append_sheet(
                    workbook,
                    worksheet,
                    "Category Wise"
                );

                XLSX.writeFile(
                    workbook,
                    "CategoryWiseAttendanceReport.xlsx"
                );


            } catch (error) {

                console.error(
                    "Category Excel export error:",
                    error
                );

                this.showSnackbar(
                    "#b71c1c",
                    "Unable to export category report."
                );

            } finally {

                this.loader = false;

            }
        },

        downloadReligionFile() {

                this.loader = true;

                try {

                    if (
                        !this.religionWiseStudentList ||
                        this.religionWiseStudentList.length === 0
                    ) {

                        this.showSnackbar(
                            "#b71c1c",
                            "No religion data available to export."
                        );

                        this.loader = false;
                        return;
                    }


                    const workbook =
                        XLSX.utils.book_new();

                    const excelData = [];
                    excelData.push([
                        this.org_basic_data.trust_name || "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);

                    excelData.push([
                        this.org_basic_data.school_name || "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);

                    excelData.push([
                        "Religion Wise Attendance Summary Report",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);

                    excelData.push([
                        "Stream : " +
                        (this.sel_std_data
                            ? this.sel_std_data.str
                            : ""),
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);

                    excelData.push([
                        "Batch : " +
                        (this.sel_ay_data
                            ? this.sel_ay_data.ay
                            : ""),
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);

                    excelData.push([
                        "",
                        "",
                        "",
                        "",
                        "",
                        ""
                    ]);

                    const grouped = {};


                    this.religionWiseStudentList.forEach(row => {

                        const standard =
                            row.standard || "Unknown";

                        if (!grouped[standard]) {
                            grouped[standard] = [];
                        }

                        grouped[standard].push(row);

                    });
                    Object.keys(grouped).forEach(standard => {

                        const rows = grouped[standard];
                        excelData.push([
                            "Standard : " + standard,
                            "",
                            "",
                            "",
                            "",
                            ""
                        ]);
                        excelData.push([
                            "Sr.No.",
                            "Division",
                            "Religion",
                            "Boys",
                            "Girls",
                            "Total"
                        ]);

                        rows.forEach((row, index) => {

                            const boys =
                                Number(row.boys_count || 0);

                            const girls =
                                Number(row.girls_count || 0);

                            excelData.push([
                                index + 1,
                                row.division || "",
                                row.religion_name || "",
                                boys,
                                girls,
                                boys + girls
                            ]);

                        });
                        const totalBoys = rows.reduce(
                            (sum, row) =>
                                sum + Number(row.boys_count || 0),
                            0
                        );

                        const totalGirls = rows.reduce(
                            (sum, row) =>
                                sum + Number(row.girls_count || 0),
                            0
                        );

                        const grandTotal =
                            totalBoys + totalGirls;


                        excelData.push([
                            "",
                            "",
                            "Total",
                            totalBoys,
                            totalGirls,
                            grandTotal
                        ]);


                        // Empty row
                        excelData.push([
                            "",
                            "",
                            "",
                            "",
                            "",
                            ""
                        ]);

                    });

                    const worksheet =
                        XLSX.utils.aoa_to_sheet(excelData);


                    worksheet["!merges"] = [];


                    // Header merges

                    worksheet["!merges"].push({
                        s: { r: 0, c: 0 },
                        e: { r: 0, c: 5 }
                    });

                    worksheet["!merges"].push({
                        s: { r: 1, c: 0 },
                        e: { r: 1, c: 5 }
                    });

                    worksheet["!merges"].push({
                        s: { r: 2, c: 0 },
                        e: { r: 2, c: 5 }
                    });

                    worksheet["!merges"].push({
                        s: { r: 3, c: 0 },
                        e: { r: 3, c: 5 }
                    });

                    worksheet["!merges"].push({
                        s: { r: 4, c: 0 },
                        e: { r: 4, c: 5 }
                    });
                    worksheet["!cols"] = [
                        { wch: 10 },
                        { wch: 15 },
                        { wch: 25 },
                        { wch: 15 },
                        { wch: 15 },
                        { wch: 15 }
                    ];
                    const range =
                        XLSX.utils.decode_range(
                            worksheet["!ref"]
                        );


                    for (
                        let row = range.s.r;
                        row <= range.e.r;
                        row++
                    ) {

                        for (
                            let col = range.s.c;
                            col <= range.e.c;
                            col++
                        ) {

                            const cell =
                                XLSX.utils.encode_cell({
                                    r: row,
                                    c: col
                                });

                            if (!worksheet[cell]) {
                                continue;
                            }

                            worksheet[cell].s = {
                                alignment: {
                                    horizontal: "center",
                                    vertical: "center"
                                }
                            };

                        }

                    }
                    for (
                        let row = range.s.r;
                        row <= range.e.r;
                        row++
                    ) {

                        const religionCell =
                            worksheet[
                                XLSX.utils.encode_cell({
                                    r: row,
                                    c: 2
                                })
                            ];

                        if (
                            religionCell &&
                            religionCell.v === "Total"
                        ) {

                            for (let col = 0; col <= 5; col++) {

                                const cell =
                                    XLSX.utils.encode_cell({
                                        r: row,
                                        c: col
                                    });

                                if (worksheet[cell]) {

                                    worksheet[cell].s = {
                                        font: {
                                            bold: true
                                        },
                                        alignment: {
                                            horizontal: "center",
                                            vertical: "center"
                                        }
                                    };

                                }

                            }

                        }

                    }

                    XLSX.utils.book_append_sheet(
                        workbook,
                        worksheet,
                        "Religion Wise"
                    );

                    XLSX.writeFile(
                        workbook,
                        "ReligionWiseAttendanceReport.xlsx"
                    );


                } catch (error) {

                    console.error(
                        "Religion Excel export error:",
                        error
                    );

                    this.showSnackbar(
                        "#b71c1c",
                        "Unable to export religion report."
                    );

                } finally {

                    this.loader = false;

                }
            },
            getFiltered(e) {
                this.filterArr = e;
            },
            dataValueList(column) {
                return [...new Set(this.mainList.map(item => item[column]))];
            },
            convert(date) {
                var datearray = date.split("-");
                var newdate = datearray[2] + "/" + datearray[1] + "/" + datearray[0];
                return newdate;
            },
            getStream() {
                this.std_div_list = null;
                this.sel_std_data = null;
                //   this.div_list = null;
                //   this.div = null;
                //   this.std_div_list = ["All"];
                //   this.sel_std_data ="All";
                this.std_div_list = this.sel_ay_data.str_list;
                //   this.std_div_list.unshift("All");
            },
            putnull() {
                this.mainList = [];
            },
            CallByReports(){
                if(this.report==0){
                    this.getStudents();
                } else {
                    this.getCategoryWiseStudents();
                }
            },
            getStudents() {
                // console.log("this.div.div_id: "+this.div)
                // console.log("this.sel_std_data: "+this.sel_std_data)
                let formData;
                this.fetch_loader = true;
                let ay;
                var stream;
                ay;
                stream = this.sel_std_data.str_id;

                if (this.sel_ay_data.ay_id) {
                    ay = this.sel_ay_data.ay_id;
                } else if (this.sel_ay_data.id) {
                    ay = this.sel_ay_data.id;
                }

                formData = {
                    ay: ay,
                    stream: this.sel_std_data.str_id,
                    date: this.date,
                    to_date: this.to_date,
                    status: this.status,
                    division: this.div
                };
                console.log(": ", formData);

                axios
                    .post("/Academics/getAttendanceSummaryReport", formData)
                    .then((res) => {
                        if (res.data.final_list.length != 0) {
                            this.mainList = res.data.final_list;
                            this.org_basic_data = res.data.org_basic_data;
                            this.fetch_loader = false;
                            this.new_date = this.convert(this.date);
                        } else {
                            this.showSnackbar("#b71c1c", "No data found!"); // show snackbar
                            this.mainList = null;
                            this.fetch_loader = false;
                        }
                    })
                    .catch((error) => {
                        // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        ay = null;
                        this.fetch_loader = false;
                    });
            },
            getCategoryWiseStudents() {
                let formData;
                this.fetch_loader = true;
                let ay;
                var stream;
                ay;
                stream = this.sel_std_data.str_id;

                if (this.sel_ay_data.ay_id) {
                    ay = this.sel_ay_data.ay_id;
                } else if (this.sel_ay_data.id) {
                    ay = this.sel_ay_data.id;
                }

                formData = {
                    ay: ay,
                    stream: this.sel_std_data.str_id,
                    status: this.status,
                    division: this.div
                };
                console.log(": ", formData);

                axios
                    .post("/Academics/getCategoryWiseAttendanceReport", formData)
                    .then((res) => {
                        if (res.data.final_list.length != 0) {
                            this.categoryWiseStudents = res.data.final_list;
                            this.religionWiseStudentList = res.data.final_religion_list;
                            this.categoryList = res.data.category_list;
                            this.religionList = res.data.religion_list;
                            this.final_religion_list = res.data.final_religion_list;
                            this.org_basic_data = res.data.org_basic_data;
                            this.fetch_loader = false;
                            this.new_date = this.convert(this.date);
                        } else {
                            this.showSnackbar("#b71c1c", "No data found!"); // show snackbar
                            this.categoryWiseStudents = null;
                            this.fetch_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        ay = null;
                        this.fetch_loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/getAyStream")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        //  this.sel_ay_data = res.data.curr_ay;
                        // this.div_list = res.data.div_list
                        this.div_list = [{ id: 'ALL', division: 'All' }, ...res.data.div_list];
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => { });
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
        },

        mounted() {
            this.onload();
        },
    };
</script>

<style scoped>
    @media print {

        header,
        footer,
        nav,
        date {
            display: none !important;
        }

        img {
            width: 100% !important;
        }

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }

        @page {
            margin-top: none;
            padding-top: none;
            size: 15.5in 15.5in;
        }

        thead {
            text-align: center !important;
            margin: none;
            padding: 1rem !important;
            font-size: xx-large !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }

    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }

    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }

    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }

    @media (min-width: 320px) {

        td,
        th {
            display: table-cell !important;
            font-size: small;
        }

        td+td,
        th+th {
            width: auto;
            font-size: small;
        }
    }

    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
</style>